/**
 * Where a product-page field must land when a mobile focus mode closes:
 * its `.pp__section` (heading + input + helper) with the heading `gap` px
 * below the sticky gallery (`.pp__gallery`, sticky on photo AND 3D pages).
 *
 * Consumed by `useProductPage.closeFocusMode` (textfield focus card) and passed
 * to the DS `Input` as `mobileFocusReveal` by the product controls that render
 * searchable dropdowns, so both paths use one rule. The DS Input itself never
 * knows these class names.
 */
export const PRODUCT_FOCUS_REVEAL = Object.freeze({
  section: '.pp__section',
  sticky: '.pp__gallery',
  gap: 20,
  align: 'top',
});

export default PRODUCT_FOCUS_REVEAL;
